import { API_ORDERS, API_POST_ORDER_SERVICES_QUOTATIONS_FIND } from "@/constants"

// Различные методы для работы с заказами
export const orderMethods = {
    data() {
        return {
            dataOverlay: false,
            isOpenServiceDistributionModal: false,
        }
    },
    methods: {
        updateOneOrderByIndex(index) {
            if (index != -1) {
                let id = this.items.data[index].id
                api.call("get", `${API_ORDERS}/${id}`).then(({data}) => {
                    this.items.data[index] = Object.assign(this.items.data[index], data)
                }).finally(() => {
                })
            }
        },
        async closeOrderByIndex(index) {
            let id = this.items.id
            let status_id = 362                     // Заказ закрыт
            let radioButtonList = structuredClone(this.$store.getters.GROUPED_REFERENCE_PROPERTIES[36])
            let updateFields = {
                reference_status_id: status_id,
                reference_close_reason_id: 368,
                close_comment: ''
            }

            let radioButtonHTML = ''
            
            radioButtonList.sort((a, b) => {
                return a.ordering_number - b.ordering_number;
            });
            radioButtonList.forEach((property, index) => {
                let checked = ''
                if (index == 0) { checked = 'checked'}
                if (property.id == 364) {
                    property.name = property.name + ' (в комментариях нужно указать какая именно услуга оказалась дороже и на сколько)';
                }
                if (property.id == 365) {
                    property.name = property.name + ' (в комментариях указать какие: условия оплаты, сроки доставки и т.д.)';
                }
                if (property.id == 366) {
                    property.name = property.name + ' (в комментариях указать причину почему не мы, если удалось выяснить у клиента)';
                }
                if (property.id == 953) {
                    property.name = property.name + ' (в комментариях указать, какой именно сервис требовался клиенту)';
                }
                
                radioButtonHTML += `<div class="custom-control custom-radio">
                    <input type="radio" id="closingOrderReason${index}" ${checked} name="closingOrderReason" class="custom-control-input" value="${property.id}">
                    <label class="custom-control-label" for="closingOrderReason${index}">${property.name}</label>
                </div>`
            })

            radioButtonHTML = `<div class="text-left">
                                    ${radioButtonHTML}
                                    <div class="form-group mt-4">
                                        <label for="closingOrderReasonComment">Комментарий</label>
                                        <textarea class="form-control" id="closingOrderReasonComment" rows="3"></textarea>
                                    </div>
                                </div>`

            // we ask for stay comment
            await this.$swal.fire({
                title: 'Укажите причину',
                html: radioButtonHTML,
                focusConfirm: false,
                showCancelButton: true,
                cancelButtonText: 'Передумал(а)',
                confirmButtonText: 'Закрыть заявку',
                showLoaderOnConfirm: true,
                onOpen: function (){
                    let closingOrderReasonComment = document.getElementById('closingOrderReasonComment')
                    let button = document.querySelector('.swal2-confirm')
                    // button.disabled = true
                    let radios = document.getElementsByName('closingOrderReason')
                    radios.forEach((radio, index) => {
                        radio.addEventListener('change', (e) => {
                            if (['363', '367', '584', '952'].includes(e.target.value)) {
                                button.disabled = false
                            } else {
                                if(closingOrderReasonComment.value.length <= 3) {
                                    button.disabled = true
                                } else {
                                    button.disabled = false
                                }
                                closingOrderReasonComment.addEventListener('input', (e) => {
                                    if(e.target.value.length > 3) {
                                        button.disabled = false
                                    } else {
                                        button.disabled = true
                                    }
                                });            
                            }
                        });            
                    })
                },
                preConfirm: async () => {
                    let radios = document.getElementsByName('closingOrderReason')
                    radios.forEach((radio, index) => {
                        if (radio.type == "radio" && radio.checked) {
                            updateFields.reference_close_reason_id = Number(radio.value)
                        }
                    })
                    updateFields.close_comment = document.getElementById("closingOrderReasonComment").value
                    return await this.updateAnyOrder(id, updateFields, index)
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
            }).finally(() => {
            })
        },
        async changeOrderStatusByID(id, newStatus = 361) {
            let status_id = newStatus                     // Заказ завершен
            let updateFields = {
                reference_status_id: status_id,
                close_comment: this.items.close_comment
            }

            if (status_id == 361) {
                let successClosingOrderHTML = `<div class="text-left">
                                            <div class="form-group mt-4">
                                                <label for="successClosingOrderComment">Комментарий (пару слов о заказе)</label>
                                                <textarea class="form-control" id="successClosingOrderComment" rows="3">${updateFields.close_comment ? updateFields.close_comment : ''}</textarea>
                                            </div>
                                        </div>`

                // we ask for stay comment
                return await this.$swal.fire({
                    title: 'Отлично! Завершаем поставку?',
                    html: successClosingOrderHTML,
                    focusConfirm: false,
                    showCancelButton: true,
                    cancelButtonText: 'Передумал(а)',
                    confirmButtonText: 'Завершаем',
                    showLoaderOnConfirm: true,
                    preConfirm: async () => {
                        updateFields.close_comment = document.getElementById("successClosingOrderComment").value
                        return await this.updateAnyOrder(id, updateFields)
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
            } else if (status_id == 421) {
                let successClosingOrderHTML = `<div class="text-left">
                                            <div class="form-group mt-4">
                                                <label for="successClosingOrderComment">Комментарий (пару слов о заказе)</label>
                                                <textarea class="form-control" id="successClosingOrderComment" rows="3">${updateFields.close_comment ? updateFields.close_comment : ''}</textarea>
                                            </div>
                                            <p class="small text-muted text-center mb-0">Если не все счета оплачены, поставка автоматически перейдет в статус «Ожидает оплаты».</p>
                                        </div>`

                // we ask for stay comment
                return await this.$swal.fire({
                    title: 'Отлично! Все счета оплачены и закрыты?',
                    html: successClosingOrderHTML,
                    focusConfirm: false,
                    showCancelButton: true,
                    cancelButtonText: 'Передумал(а)',
                    confirmButtonText: 'Да, закрываем',
                    showLoaderOnConfirm: true,
                    preConfirm: async () => {
                        updateFields.close_comment = document.getElementById("successClosingOrderComment").value
                        return await this.updateAnyOrder(id, updateFields)
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
            } else {
                return await this.updateAnyOrder(id, updateFields)
            }

        },
        findElementIndexById(id) {
            return this.items.data.findIndex((element, index, array) => {
                return element.id == id
            })
        },
        updateAnyOrder(id, data, index = -1) {
            const makingOrderSupply = data.makingOrderSupply

            return api.call("put", `${API_ORDERS}/${id}`, data).then(({data}) => {
                if (index != -1) {
                  Object.assign(this.items.data[index], data)
                  Object.assign(this.detailedItem, data)
                  this.items.data[index].loading = false
                }
                if (this.detailedItem && this.detailedItem.loading) {
                    Object.assign(this.detailedItem, data)
                    this.detailedItem.loading = false
                }
                this.validationErrors = ''
                
                // Проверяем, переводится ли заказ в поставку
                if (data.reference_order_type_id == 2 && makingOrderSupply == true) {
                    // Красивое модальное окно о переводе в поставку
                    this.$swal.fire({
                        title: 'Заявка успешно переведена в поставку!',
                        html: `
                            <div class="text-center">
                                <p class="text-muted">Чтобы все изменения вступили в силу, страница автоматически перезагрузится через несколько секунд.</p>
                            </div>
                        `,
                        icon: 'success',
                        showConfirmButton: false,
                        showClass: {
                            popup: 'animate__animated animate__fadeInDown'
                        },
                        hideClass: {
                            popup: 'animate__animated animate__fadeOutUp'
                        },
                        timer: 10000,
                        timerProgressBar: true,
                        allowOutsideClick: false
                    });

                    setTimeout(() => {
                        window.location.reload();
                    }, 7000);
                } else {
                    this.makeToast('info', 'Изменения в заказе сохранены')
                }

                return true
            }).catch((response) => {
                if (response.status == 422){
                    this.validationErrors = response.data.error
                }
            })
        },
        async finalFormValidate(checkItem) {
            const h = this.$createElement
            let message = []

            if (!checkItem.company_id) {
                message.push(h('li', "- Выберите компанию клиента"))
            }
            if (!checkItem.company_employee || (checkItem.company_employee && !checkItem.company_employee.lead_phone)) {
                message.push(h('li', "- Укажите, как минимум, телефон клиента"))
            }
            if (checkItem.set_categories_ids.length == 0) {
                message.push(h('li', "- Укажите категории заказа"))
            }
            if (!checkItem.reference_sources_id) {
                message.push(h('li', "- Укажите источник поставки"))
            }
            if (checkItem.set_services_ids.length == 0) {
                message.push(h('li', "- Заказ должен содержать хотя бы одну услугу"))
            }
            if (!checkItem.receive_datetime) {
                message.push(h('li', "- Укажите дату получения заявки"))
            }
            if (!checkItem.processing_end_datetime) {
                message.push(h('li', "- Укажите дату отработки заявки"))
            }
            if (checkItem.documents_count < 1) {
                if (!checkItem.comment) {
                    message.push(h('li', "- Прикрепите к заявке документы или оставьте комментарий"))
                }
            }

            if (checkItem.services.length > 0) {
                for (const service of checkItem.services) {
                    // Если есть логистика, у нее должен быть выбран ТИП, иначе не допускаем к Поставке (правила от Барбашиной, февраль 2025)
                    if (service.pivot.reference_service_id === 23) {
                        if (!service.pivot.reference_property_type_id) {
                            message.push(h('li', "- Выберите Тип поставки в услуге Логистика"))
                        }
                        
                        // Проверяем, выбрана ли котировка в логистике
                        try {
                            // Делаем запрос к бэкенду для получения данных котировки
                            const params = {
                                order_id: checkItem.id,
                                order_service_id: service.pivot.id
                            };
                            
                            const { data } = await api.call('post', API_POST_ORDER_SERVICES_QUOTATIONS_FIND, params);
                            if (data.success && data.quotation && data.quotation.data) {
                                const quotationData = data.quotation.data;
                                
                                // Проверяем, выбран ли transport_types_id в котировке
                                if (!quotationData.transport_types_id) {
                                    message.push(h('li', "- Необходимо выбрать котировку в Логистике, с которой мы будем работать"))
                                }
                            } else {
                                // Если котировка не найдена или нет данных
                                message.push(h('li', "- Необходимо выбрать котировку в Логистике, с которой мы будем работать"))
                            }
                        } catch (error) {
                            console.error('Ошибка при получении данных котировки:', error);
                            message.push(h('li', "- Необходимо выбрать котировку в Логистике, с которой мы будем работать"))
                        }
                    }
                }
            }

            return message
        },
    }
}
